import './SomethingWentWrong.css';

import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { NavigateButton } from '../Button';
import image from './something-went-wrong.webp';

interface SomethingWentWrongProps {
  withButton: boolean;
}

export const SomethingWentWrong: FunctionComponent<SomethingWentWrongProps> = ({
  withButton,
}) => {
  const { t } = useTranslation();

  return (
    <div className="something-went-wrong-container">
      <img src={image} width={308} />
      <div className="something-went-wrong-title-container">
        <p className="text-2xl semibold">
          {t('components.SomethingWentWrong.title')}
        </p>
        <p className="text-base regular">
          {t('components.SomethingWentWrong.subtitle')}
        </p>
      </div>
      {withButton && (
        <div>
          <NavigateButton
            label={t('components.SomethingWentWrong.buttonLabel')}
            theme="secondary"
            size="large"
            to="/patient-list"
            linkProps={{ replace: true }}
          />
        </div>
      )}
    </div>
  );
};
